import { Component, OnInit } from '@angular/core';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';

@Component({
    selector: 'enable-automatic-booking-onboarding',
    templateUrl: './enable-automatic-booking-onboarding.html',
    standalone: false
})

export class EnableAutomaticBookingOnboarding implements OnInit {

  constructor(
    public onboardingProvider: OnboardingProvider,
    private storage: TidyStorage,
    public windowService: WindowService,
    private rightSidePanelService: RightSidePanelService
  ) {}

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Auto-Schedule');
    await this.storage.save('cameFromIntegrations', false);
  }
}